module.exports = __webpack_public_path__ + "static/media/first-view-mockup.e1a2e77d.png";